.card {
  width: 100%;
  padding: 2rem;
  background-color: var(--ib-panel);
  border: 1px solid var(--ib-line);
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(27, 37, 52, 0.05), 0 10px 30px rgba(120, 30, 30, 0.08);
  display: flex;
  flex-direction: column;
}

.passwordTitle {
  display: flex;
  flex-direction: column;
  margin-bottom: 1.25rem;
}

.inputs {
  display: flex;
  flex-direction: column;
}

.input {
  position: relative;
  margin-bottom: 1rem;
}

/* Restyle the actual <input> rendered inside the Input component wrapper */
.input input {
  width: 100%;
  border: 1px solid var(--ib-line);
  border-radius: 8px;
  padding: 0.65rem 0.85rem;
  color: var(--ib-ink);
  font-variant-numeric: tabular-nums lining-nums;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.input input:focus {
  outline: 0;
  border-color: var(--ib-red);
  box-shadow: 0 0 0 3px var(--ib-red-soft);
}

.welcomeText {
  margin: 0.5rem 0 0.5rem 0;
}

.errorMessage {
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
  padding-left: 0.1rem;
  min-height: 10px;
}

.buttonsWrapper {
  display: flex;
  gap: 0.75rem;
  margin: 1.5rem 0 0.5rem 0;
}

.card .backToLogin {
  flex: 1;
  border-radius: 8px;
  padding: 0.6rem 1rem;
}

.card .resetBtn {
  flex: 1;
  border-radius: 8px;
  padding: 0.7rem 1rem;
  font-weight: 600;
}

.card .resetBtn:not(:disabled) {
  background-color: var(--ib-red);
  border-color: var(--ib-red);
}

.card .resetBtn:not(:disabled):hover {
  background-color: var(--ib-red-d);
  border-color: var(--ib-red-d);
}
